import { geniFetch } from "../geniBackend";

/**
 * Отключение Kaspi: бэкенд чистит только metadata.kaspi/kaspiMerchantId и НЕ трогает общую
 * колонку marketplaceToken (её использует WB-импорт) — поэтому отключение Kaspi не сбрасывает WB.
 */
export async function disconnectKaspi(): Promise<void> {
  await geniFetch("/kaspi/disconnect", { method: "POST", body: "{}" });
}
